import { Link, useParams, useLocation } from 'react-router-dom'
import { getArea, contarProntos, type ColetorModulo } from '../nav/coletor-nav'

/* ============================================================================
 * Coletor - Modulos de uma area (2o nivel) | ADR-0034 F2b
 * Mostra os modulos da area com os 3 estados (mapa vivo do progresso):
 *   ligado      -> azul, clicavel (Link to /m/*)
 *   por-portar  -> cinza, inerte (existe no PC, sem ecra coletor)
 *   ecossistema -> roxo, inerte (a ligar)
 * ========================================================================== */
export default function Area() {
  const { id = '' } = useParams()
  const loc = useLocation()
  const qs = loc.search || ''
  const area = getArea(id)

  if (!area) {
    return (
      <div className="py-6 text-center">
        <div className="text-sm" style={{ color: 'var(--tx-secondary)' }}>
          Area nao encontrada.
        </div>
        <Link
          to={`/m/home${qs}`}
          className="text-xs underline"
          style={{ color: 'var(--col-action-ico)' }}
        >
          Voltar
        </Link>
      </div>
    )
  }

  const prontos = contarProntos(area)
  const total = area.modulos.length

  return (
    <div className="py-3 select-none">
      <div className="px-1 mb-3 flex items-center gap-2">
        <Link
          to={`/m/home${qs}`}
          className="w-8 h-8 rounded-lg flex items-center justify-center"
          style={{ background: 'var(--bg-icon-tile)' }}
          aria-label="Voltar"
        >
          <span
            className="text-lg leading-none"
            style={{ color: 'var(--col-action-ico)' }}
          >
            {'‹'}
          </span>
        </Link>
        <div className="flex-1">
          <div className="font-semibold" style={{ color: 'var(--tx-primary)' }}>
            {area.label}
          </div>
          <div className="text-xs" style={{ color: 'var(--tx-secondary)' }}>
            {`${total} modulos · ${prontos} prontos`}
          </div>
        </div>
      </div>

      <div className="grid grid-cols-2 gap-3">
        {area.modulos.map((m) => (
          <ModuloCard key={m.id} modulo={m} qs={qs} />
        ))}
      </div>
    </div>
  )
}

function ModuloCard({ modulo, qs }: { modulo: ColetorModulo; qs: string }) {
  const Icon = modulo.icon
  const ligado = modulo.estado === 'ligado'
  const eco = modulo.estado === 'ecossistema'

  const inner = (
    <>
      <div
        className="mb-2 w-9 h-9 rounded-lg flex items-center justify-center"
        style={{
          background: ligado
            ? 'var(--bg-icon-tile)'
            : eco
              ? 'rgba(150,120,220,.15)'
              : 'rgba(255,255,255,.05)',
        }}
      >
        <Icon
          size={20}
          style={{
            color: ligado
              ? 'var(--col-action-ico)'
              : eco
                ? 'var(--col-eco)'
                : '#6c7686',
          }}
        />
      </div>
      <div
        className="font-medium text-sm"
        style={{
          color: ligado ? 'var(--tx-primary)' : eco ? '#c9bce4' : '#9aa3b3',
        }}
      >
        {modulo.label}
      </div>
      <div
        className="text-[10px] mt-0.5"
        style={{ color: 'var(--tx-secondary)' }}
      >
        {ligado ? modulo.hint : eco ? 'a ligar' : 'no PC'}
      </div>
    </>
  )

  if (ligado && modulo.to) {
    return (
      <Link
        to={`${modulo.to}${qs}`}
        className="group relative p-3 tile-3d cursor-pointer min-h-[92px] flex flex-col"
      >
        {inner}
      </Link>
    )
  }

  return (
    <div
      className="relative p-3 tile-3d min-h-[92px] flex flex-col"
      style={{
        background: eco ? 'var(--bg-eco)' : 'var(--bg-card-muted)',
        borderColor: eco ? 'var(--bd-eco)' : 'var(--bd-card-muted)',
        opacity: 0.6,
        cursor: 'default',
      }}
    >
      {inner}
    </div>
  )
}
